'use client'


import { EditSaleOrderStatus , getProperReturnLabel, getProperReturnValue } from '../../utils'

import SubmitEditSaleOrderModalChangedItem from './SubmitEditSaleOrderModalChangedItem'

const SubmitEditSaleOrderModalDetailsSection = ({
  editStatusObject
}: {
  editStatusObject: EditSaleOrderStatus
}) => {
  if (editStatusObject === null) return

  return (
    <>
      {editStatusObject.products && (
        <SubmitEditSaleOrderModalChangedItem
          changedTitle='Produkty'
          firstStartLabel='Aktualny koszyk'
          firstStartElement={editStatusObject.products.start.length}
          firstChangedElement={editStatusObject.products.current.length}
          secondChangedElement={
            editStatusObject.products.current.productsRemoved
          }
          thirdChangedElement={editStatusObject.products.current.productsAdded}
        />
      )}

      <SubmitEditSaleOrderModalChangedItem
        changedTitle='Adres dostawy'
        firstStartLabel='Aktualny adres'
        firstStartElement={editStatusObject.deliveryAddress.start?.name}
        secondStartElement={editStatusObject.deliveryAddress.start.firstLine}
        thirdStartElement={editStatusObject.deliveryAddress.start.secondLine}
        firstChangedElement={editStatusObject.deliveryAddress.current.name}
        secondChangedElement={
          editStatusObject.deliveryAddress.current.firstLine
        }
        thirdChangedElement={
          editStatusObject.deliveryAddress.current.secondLine
        }
      />

      <SubmitEditSaleOrderModalChangedItem
        changedTitle='Termin dostawy'
        firstStartLabel='Aktualny termin'
        firstStartElement={editStatusObject.deliveryTime.start.date}
        secondStartElement={editStatusObject.deliveryTime.start.time}
        firstChangedElement={editStatusObject.deliveryTime.current.date}
        secondChangedElement={editStatusObject.deliveryTime.current.time}
      />

      <SubmitEditSaleOrderModalChangedItem
        changedTitle='Kody rabatowe'
        firstStartLabel='Aktualne kody rabatowe:'
        firstStartElement={editStatusObject.discountCodes.start.name ?? 'Brak'}
        secondStartElement={editStatusObject.discountCodes.start.value?.replaceAll(
          '&nbsp;',
          ' '
        )}
        firstChangedElement={
          editStatusObject.discountCodes.current.name ?? 'Brak'
        }
        secondChangedElement={editStatusObject.discountCodes.current.value?.replaceAll(
          '&nbsp;',
          ' '
        )}
      />

      <SubmitEditSaleOrderModalChangedItem
        changedTitle='Metoda płatności'
        firstStartLabel='Aktualna metoda płatności:'
        firstStartElement={editStatusObject.paymentMethod.start.name}
        secondStartLabel={
          editStatusObject.wasOnDelivery ? 'Do zapłaty' : 'Zapłacono:'
        }
        secondStartElement={editStatusObject.payment.start.paid}
        firstChangedElement={editStatusObject.paymentMethod.current.name}
        secondChangedLabel={
          editStatusObject.wasOnDelivery
            ? 'Do zapłaty'
            : getProperReturnLabel(editStatusObject.payment.current.diffValue)
        }
        secondChangedElement={
          editStatusObject.wasOnDelivery
            ? editStatusObject.payment.current.paid
            : getProperReturnValue(editStatusObject.payment.current.diffValue)
        }
      />
    </>
  )
}

export default SubmitEditSaleOrderModalDetailsSection
